<template>
    <div class="flex flex-col gap-1 text-sm lg:items-end" v-if="variant === 'large'">
        <!-- Score + stars -->
        <div class="flex gap-0.5 items-baseline text-primary">
            <strong class="mr-1.5 text-3xl">
                {{ avgScore.score.toFixed(1) }}
            </strong>

            <template v-for="(star, index) in stars">
                <i class="icon-star text-base" :class="{ 'opacity-60': star === 'half' }" />
            </template>
        </div>

        <!-- Label + count -->
        <div class="text-sm space-x-1">
            <span class="font-semibold capitalize">{{ avgScore.label }}</span>
            <span class="text-gray-500">({{ $t('Count reviews :count', { count: avgScore.count }) }})</span>
        </div>
    </div>

    <div class="flex flex-row gap-1 text-sm items-center flex-wrap" v-if="variant === 'small'">
        <!-- Score + stars -->
        <div class="flex gap-0.5 items-center text-pink-400">
            <strong class="mr-1 text-base">
                {{ avgScore.score.toFixed(1) }}
            </strong>

            <template v-for="(star, index) in stars">
                <i class="icon-star text-sm" :class="{ 'opacity-60': star === 'half' }" />
            </template>
        </div>

        <!-- Label + count -->
        <div class="text-sm space-x-1">
            <span class="font-semibold capitalize">{{ avgScore.label }}</span>
            <span class="text-gray-500">({{ $t('Count reviews :count', { count: avgScore.count }) }})</span>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    avgScore: {
        type: Object,
        required: true
    },
    variant: {
        type: String,
        default: 'small'
    }
})

const stars = computed(() => {
    const full = Math.floor(props.avgScore.score)
    const half = props.avgScore.score % 1 >= 0.5 ? 1 : 0

    return [...Array(full).fill('full'), ...Array(half).fill('half')]
})
</script>
